import { HubJsonRpcRequest } from '../api/HubJsonRpcRequest';
import { HubApiMethods } from '../constants/HubApiMethods';
import { CurrentUser } from '../general/modules/user/currentUser';
import { HubApiRequestError } from '../api/HubApiRequestError';
import { ClusterConfig } from '../types/server';

type GetMaintenanceDataResponse = {
    cluster: ClusterConfig
    maintenanceData: {
        isOn: boolean,
        startTime: number
    },
    staticBaseUrl: string
    compensationStaticUrl: string
};

type GetMaintenanceDataRequest = {
    suid: string,
    token: string,
    cluster: string
}

export class MaintenanceMode {
    public static async getStateData(): Promise<GetMaintenanceDataResponse> {
        const currentUser = CurrentUser.getInstance();
        const response = await HubJsonRpcRequest.makeRequest<GetMaintenanceDataResponse, GetMaintenanceDataRequest>(
            HubApiMethods.GET_MAINTENANCE_DATA,
            {
                cluster: window.app.config.cluster_name,
                suid: String(currentUser.getSuid()),
                token: currentUser.getAuthToken()
            },
            window.app.deviceIdentifier
        );

        if ('error' in response) {
            throw new HubApiRequestError(response.error.message);
        }

        return response;
    }
}
